(() => {
  const sections = document.querySelectorAll('[data-blocks-grid]');
  if (!sections.length) return;

  const animateCount = (el, value) => {
    if (el.dataset.animated === 'true') return;
    el.dataset.animated = 'true';

    const target = Number(value);
    const safeTarget = Number.isFinite(target) ? Math.max(0, target) : 0;
    const duration = target > 100 ? 1600 : 3000;
    const startTime = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const current = Math.floor(safeTarget * progress);
      el.textContent = current.toString();
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = safeTarget.toString();
      }
    };

    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const numbers = entry.target.querySelectorAll('[data-value]');
        numbers.forEach((numberEl) => {
          animateCount(numberEl, numberEl.dataset.value);
        });
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.3 }
  );

  sections.forEach((section) => observer.observe(section));
})();
